module.exports = __webpack_public_path__ + "img/pleisure_bodyimage13-2.09ae9956.jpg";